export const PARAMS = {
  SESSION_ID: ':sessionId',
  DOCUMENT_ID: ':documentId',
  FOLDER_ID: ':folderId',
  SUBSCRIPTION_ID: ':subscriptionId',
  CUSTOMER_ID: ':customerId',
  TOKEN: ':token',
  ORGANIZATION_ID: ':organizationId',
  PRODUCT: ':product',
  RESELLER_ID: ':resellerId',
  MODEL_ID: ':modelId',
  PLAN_ID: ':planId',
  LANGUAGE_ID: ':languageId',
  GLOSSARY_ID: ':glossaryId'
};

export const PATHS = (
  arg1: string = '',
  arg2: string = '',
  arg3: string = ''
) => {
  return {
    NOT_FOUND: '*',
    HOME: '/',
    MAINTENANCE: '/maintenance',
    LOGIN: '/login',
    RESET_PASSWORD: '/reset-password',
    PASSWORD_RESET: '/login/password_reset',
    CHANGE_PASSWORD: '/change-password',
    REGISTER: '/register',
    REGISTER_WITH_SUBSCRIPTION: '/register-with-subscription',
    SUBSCRIBE: '/subscribe',
    ACTIVATE_USER: '/login/activate',
    THANK_YOU_REGISTER: `/thank-you-for-purchasing/${PARAMS.ORGANIZATION_ID}/${PARAMS.PRODUCT}`,
    LOGIN_MICROSOFT: '/auth-callback/microsoft',
    OAUTH_CALLBACK: '/oauth/callback',
    TRANSCRIPT_SHARED: `/transcripts/shared/${arg1}/${arg2}/${arg3}`,
    TRANSCRIPT: `/transcripts/${arg1}/${arg2}`,
    CAPTION_SHARED: `/captions/shared/${arg1}/${arg2}/${arg3}`,
    CAPTIONS: `/captions/${arg1}/${arg2}`,
    REALTIME_EDITOR: '/realtime',
    FOLDER_CONTENT: `/folders/${arg1}`,
    CUSTOMER_CONTENT: `/back-office/customers/${arg1}`,
    CUSTOMER_PROFILE: `/back-office/customers/${arg1}/profile`,
    CUSTOMER_TOKENS: `/back-office/customers/${arg1}/tokens`,
    CUSTOMER_SUBSCRIPTIONS: `/back-office/customers/${arg1}/subscriptions`,
    CUSTOMER_MANDATES: `/back-office/customers/${arg1}/mandates`,
    CUSTOMER_IAM: `/back-office/customers/${arg1}/iam`,
    CUSTOMER_ACTIVITY: `/back-office/customers/${arg1}/activity`,
    CUSTOMER_WEBHOOKS: `/back-office/customers/${arg1}/webhooks`,
    CUSTOMER_TEMPLATES: `/back-office/customers/${arg1}/templates`,
    CUSTOMER_EXCEEDANCES: `/back-office/customers/${arg1}/exceedances`,
    CUSTOMER_AI_SUMMARY: `/back-office/customers/${arg1}/ai-summary`,
    SUBSCRIPTION_CONTENT: `/subscriptions/${arg1}`,
    PROFILE: '/profile',
    BACK_OFFICE: '/back-office',
    API_KEYS: '/api-keys',
    SPEECH_TO_TEXT_SESSIONS: '/speech-to-text-sessions',
    BILLING_AND_SUBSCRIPTION: '/billing-and-subscription',
    RESELLER: '/reseller',
    RESELLER_ORGANIZATIONS: '/reseller/organizations',
    RESELLER_USERS: '/reseller/users',
    RESELLER_CUSTOMS: `/reseller/customs`,
    RESELLER_ALL_USERS: `/reseller/all-users`,
    RESELLER_LANGUAGE_ACCESS: '/reseller/language-access',
    USERS: '/users',
    TEAMS: '/teams',

    // ================================
    // BACK OFFICE - NEW NAVIGATION (Redesign)
    // ================================
    // Primary navigation (6 items)
    BO_DASHBOARD: '/back-office/dashboard',
    CUSTOMERS: '/back-office/customers',
    PLANS: '/back-office/plans',
    BO_USAGE_REVENUE: '/back-office/usage-revenue',
    BO_OPERATIONS: '/back-office/operations',
    BO_SETTINGS: '/back-office/settings',
    BO_EXCEEDANCES: '/back-office/exceedances',

    // Plan routes
    PLAN_DETAILS: `/back-office/plans/${arg1}`,
    PLAN_CREATE: '/back-office/plans/create',
    PLAN_DUPLICATE: `/back-office/plans/${arg1}/duplicate`,

    // Usage & Revenue routes
    BO_RESELLER_USAGE_DETAIL: `/back-office/usage-revenue/reseller/${arg1}`,
    BO_ON_PREM_BILLING: '/back-office/on-prem-billing',

    // Licensing routes
    BO_LICENSING: '/back-office/licensing',

    // Session Inspector
    BO_SESSION_INSPECTOR: '/back-office/session-inspector',

    // Legacy routes (kept for backward compatibility / redirects)
    PRICE_PLANS: '/back-office/price-plans',
    BILLABLES: '/back-office/billables',
    LANGUAGE_AND_CONFIGS: '/back-office/language-and-configs',
    USAGE: '/back-office/usage',
    STRANDED_SESSIONS: '/back-office/stranded-sessions',
    PRIORITY_QUEUE: '/back-office/priority-queue',
    TRAFFIC_MONITORING: '/back-office/traffic-monitoring',
    LANGUAGE_AND_PUBLICATIONS: `/back-office/language-and-configs/${arg1}`,

    // Other routes
    RESELLER_CUSTOMER: `/reseller/${arg1}`,
    CUSTOM_MODELS: '/custom-models',
    CUSTOM_MODEL: `/custom-models/${arg1}`,
    STATUS: '/status',
    LICENSES: '/licenses',
    ACCESSIBILITY: '/accessibility',
    STT: '/speech-to-text-sessions',
    GLOSSARIES: '/glossaries',
    GLOSSARY_DETAILS: `/glossaries/${arg1}`,
    EXPORT_TEMPLATE_ITEMS: '/export-template-items',
    SPEAKERS: '/speakers',
    TAGS: '/tags',

    // ================================
    // ON-PREM ADMIN PANEL
    // ================================
    ADMIN: '/admin',
    ADMIN_DASHBOARD: '/admin/dashboard',
    ADMIN_OVERVIEW: '/admin/overview',
    ADMIN_ORGANIZATIONS: '/admin/organizations',
    ADMIN_ORGANIZATION_DETAIL: `/admin/organizations/${arg1}`,
    ADMIN_OPERATIONS: '/admin/operations',
    ADMIN_QUEUE: '/admin/queue',
    ADMIN_PLANS: '/admin/plans',
    ADMIN_LANGUAGES: '/admin/languages',
    ADMIN_TRANSLATION: '/admin/translation',
    ADMIN_SETTINGS: '/admin/settings',

    DESIGN_TOKENS: '/design-tokens'
  };
};
